import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconStarFilled = createIcon({
  viewBox: '0 0 14 13',
  path: (
    <path
      d="M7 1L5.14 4.61429L1 5.19571L4 8.02429L3.295 12L7 10.1143L10.705 12L10 8.02429L13 5.19571L8.86 4.61429L7 1Z"
      fill="#CFDAEC"
      stroke="#0D47A1"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
});

export default IconStarFilled;
